import React from "react";

const Input = ({ label, error, icon: Icon, rightElement, className = "", id, ...props }) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-bookish-purple mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <Icon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-bookish-purple/40" />
        )}
        <input
          id={inputId}
          className={`w-full border border-bookish-purple/15 rounded-lg px-3 py-2.5 text-sm bg-white min-h-[44px] focus:border-bookish-purple/40 focus:ring-2 focus:ring-bookish-purple/10 focus:outline-none placeholder:text-bookish-purple/40 transition-colors ${
            Icon ? "pl-9" : ""
          } ${rightElement ? "pr-10" : ""} ${
            error ? "border-red-400 focus:border-red-400 focus:ring-red-100" : ""
          }`}
          {...props}
        />
        {rightElement && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            {rightElement}
          </div>
        )}
      </div>
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default Input;
